import React from "react";
import styled from "styled-components";
import { IoTrash } from "react-icons/io5";
import { TiPlus, TiMinus } from "react-icons/ti";
import { useDispatch } from "react-redux";
import { dataActions } from "../../store/index.js";
import { calculateDiscountedPrice } from "../../utils/utils.ts";
import { URLPOZE } from "../../utils/constants.ts";

const TileContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  padding: 16px;
  border: 2px solid var(--background-yellow);
  border-radius: 8px;
  justify-content: space-between;
`;

const Image = styled.img`
  background-color: #f0f0f0;
  border: 1px solid var(--background-yellow);
  min-width: 80px;
  width: 80px;
  height: 80px;
`;

const Img = styled.img`
  width: auto;
  max-width: 300px;
  height: 200px;
  background-color: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(0, 0, 0, 0.3);
  object-fit: cover;

  @media (max-width: 768px) {
    height: 130px;
  }
`;

const DetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-width: 50%;
  align-items: flex-start;
  gap: 16px;
`;

const ProductName = styled.p`
  color: var(--secondary-font-color);
  font-size: 1.2rem;
  font-family: Georgia, serif;
  margin: 0;
`;

const UnitPrice = styled.p`
  color: var(--tertiary-font-color);
  font-size: 1rem;
  font-family: Verdana, sans-serif;
`;

const ProductPrice = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  align-items: center;
`;

const StrikePrice = styled.div`
  font-family: Verdana, sans-serif;
  text-decoration: line-through;
  color: var(--tertiary-font-color);
  font-size: 0.8rem;
`;

const TotalPrice = styled.p`
  color: var(--secondary-green);
  font-size: 1.2rem;
  font-family: Verdana, sans-serif;
  margin: 0;
  padding-left: 16px;
`;
const QuantityContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const RightContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
`;
const Button = styled.button`
  color: var(--secondary-green);
  display: flex;
  justify-content: center;
  cursor: pointer;
  border: none;
  background-color: var(--background-green);
  padding: 8px;
  font-size: 1.2rem;
  font-family: Verdana, sans-serif;
  border-radius: 50px;

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

const DeleteButton = styled.button`
  cursor: pointer;
  border: none;
  background-color: transparent;
  font-size: 1.2rem;
  color: var(--tertiary-font-color);
  display: flex;
  justify-content: center;
  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;
interface Props {
  productID: string;
  productName: string;
  price: number;
  image?: string;
  quantity: number;
  discount?: number;
}

const SummaryProductTile: React.FC<Props> = ({
  productID,
  productName,
  price,
  discount,
  image,
  quantity,
}) => {
  // const [totalQuantity, setTotalQuantity] = React.useState(quantity);
  const dispatch = useDispatch();
  const onDelete = () => {
    dispatch(dataActions.removeProductFromCart(productID));
  };

  return (
    <TileContainer data-testid="summary-product-tile">
      <DetailsContainer>
        {image && (
          <Image src={`${URLPOZE}${image}`} alt={`Product ${productID}`} />
        )}

        <div>
          <ProductName>{productName}</ProductName>

          {discount ? (
            <ProductPrice data-testid="product-price">
              <UnitPrice>
                {Number(price) - Number(price) * (Number(discount) / 100)} lei
              </UnitPrice>
              <StrikePrice>{price} lei</StrikePrice>
            </ProductPrice>
          ) : (
            <UnitPrice>
              {price}
              {" lei"}
            </UnitPrice>
          )}
        </div>
      </DetailsContainer>

      <RightContainer>
        <QuantityContainer>
          <Button
            onClick={() =>
              dispatch(
                dataActions.updateProductQuantity({
                  id: productID,
                  quantity: quantity - 1,
                })
              )
            }
          >
            <TiMinus />
          </Button>
          <p>{quantity}</p>
          <Button
            onClick={() =>
              dispatch(
                dataActions.updateProductQuantity({
                  id: productID,
                  quantity: quantity + 1,
                })
              )
            }
          >
            <TiPlus />
          </Button>
          <DeleteButton onClick={onDelete}>
            <IoTrash />
          </DeleteButton>
        </QuantityContainer>
        <TotalPrice>
          {calculateDiscountedPrice(price, discount) * quantity}
          {" lei"}
        </TotalPrice>
      </RightContainer>
    </TileContainer>
  );
};

export default SummaryProductTile;
